<!-- 热门 -->
<template>
  <div id="hot"
       class="hot">
    <div class="hot-title">
      <div class="word">{{$t('home.liveTitle2')}}</div>
    </div>
    <div class="wrap hotwrap">
      <div class="imgboxing"
           v-for="(item, index) in hotOnlineList.slice(0,15)"
           :key="index">
        <a class="outimg"
          :href="'/live/' + item.lgid +'.html'"
             :data-id="item.live_obj_id">
          <div class="imgbox"
               style="display: table-cell;vertical-align: middle;text-align: center;">
            <img class="picavatar"
                 :src="item.live_pic + '_200x200'"
                 v-if="item.live_pic">
            <img class="picavatar"
                 :src="item.avatar + '_200x200'"
                 v-else>
          </div>
          <div class="img-bg">
            <div class="img-bg-box">
              <div class="out-box">
                <img class="auto-img"
                     src="https://static.lespark.cn/pc_img/images/play.png">
              </div>
            </div>
          </div>
        </a>
        <img class="lala_live"
             src="https://static.lespark.cn/pc_img/images/live2.png">
        <div class="clearflow nic-view">
          <div class="fl nickname">{{item.nickname}}</div>
          <div class="lock fl"
               v-if="item.is_secret_live == '1'">
            <img src="https://static.lespark.cn/pc_img/images/lock.png" />
          </div>
          <div class="fr">
            <div class="fl"
                 style="margin-right:5px; line-height: 23px;">
              <img src="https://static.lespark.cn/pc_img/images/view.png">
            </div>
            <div class="fr view">{{item.view_num}}</div>
          </div>
        </div>
      </div>
    </div>
    <p class='viewAll' @click='goAllLive'>
      <span>{{$t('home.more')}}</span>
      <i class="el-icon-arrow-right"></i>
    </p>
  </div>
</template>
<script>
import cookie from 'Common/cookie'
import util from 'Common/util';
import "babel-polyfill";
import promise from "es6-promise";
import ajax from 'Common/ajax';
import constans from 'Constans';
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const DOMAIN = constans.APIS.domain
const userUrl = constans.AllUrl.url.dev

const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': require('static/js/zh'),
    'zh-f': require('static/js/zh-f'),
    'en': require('static/js/en')
  }
})

export default {
  name: 'hot',
  data () {
    return {
      hotOnlineList: '',
      cache_id: '', //分页参数
      last_index: '', //分页参数，为-1时,无更多数据
      scroll: '',
      roating: true,
    }
  },
  created () {
    // 热门
    ajax.Get({
      url: userUrl + "/pc_user_online_lives?t=" + new Date().getTime(),
      headers: {
        bundle_id: 'pc',
        'bundle-id': 'pc',
        lang: 'zh-hans'
      }
    }).then(ref => {
      let data = ref.data;
      this.hotOnlineList = data.online_list;
    }).catch(ref => {
    })
  },
  mounted () {
  },
  methods: {
    goAllLive(){
      window.location.href = '/live-all.html'
    },
    toLive: function (lgid,live_id) {
      window.open("/live/" + lgid +".html", "_blank");
    },
   
  }
}
</script>
<style scoped>
  .hot-title{
    height: 180px;
    line-height: 180px;
  }
  .viewAll {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #666666;
    text-align: center;
    cursor: pointer;
  }

.imgboxing {
  margin-right: 20px;
  margin-bottom: 25px;
  position: relative;
}

.imgboxing:nth-child(5n + 5) {
  margin-right: 0px;
}

.imgbox {
  width: 220px;
  height: 220px;
  overflow: hidden;
  border-radius: 3px;
}

.picavatar {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 8px;
}

.outimg {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.outimg:hover img {
  transform: scale(1.05);
  transition: all 1s ease 0s;
  -webkit-transform: scale(1.05);
  -webkit-transform: all 1s ease 0s;
}

.outimg:hover > .img-bg {
  display: block;
}

.img-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  display: none;
  border-radius: 3px;
}

.img-bg-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.out-box {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 60px;
  height: 60px;
}

.auto-img {
  width: 100%;
  min-height: 100%;
  height: auto;
  display: block;
}

.wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

/*热门*/
.hot {
  max-width: 1400px;
  min-width: 960px;
  margin: 0 auto;
}



.hot .word {
  font-size: 38px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #333333;
    letter-spacing: 1px;
    text-align: center;
}

.attention .nickname,
.hot .nickname {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  width: 124px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 23px;
}

.attention .view,
.hot .view {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #a8a8a8;
  text-align: right;
  line-height: 23px;
}

.nic-view {
  margin-top: 5px;
}

.novideoimg {
  width: 47px;
  height: 40.3px;
  margin: 0 auto;
}

.novideo {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #a8a8a8;
  letter-spacing: 0;
  text-align: center;
  margin-top: 28.7px;
}

.lock {
  width: 23px;
  height: 23px;
}

.lock > img {
  width: 15px;
  height: 15px;
}
.lala_live {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 6;
  height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/components/hot.vue